import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import NonsocialUpdate from "../nonsocial_update";
import BookWithWTRButton from "../../book_with_wtr_button";
import PreviewBook from "../../preview_book/preview_book";
import BookDescription from "../../book_description";

export default GrComponentFactory.createClass({
  displayName: "TrendingGenreNewsfeedItem",

  propTypes: {
    updateTitle: React.PropTypes.string.isRequired,
    updateIconUrl: React.PropTypes.string.isRequired,
    updateSubjects: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
      genre: React.PropTypes.shape({
        name: React.PropTypes.string.isRequired,
        genreUrl: React.PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  },

  renderHeader() {
    const updateSubjects = this.props.updateSubjects;
    return (
      <span>
        <span>{this.props.updateTitle}, </span>
        <a href={updateSubjects.genre.genreUrl}
           className="gr-hyperlink gr-hyperlink--bold">
          {updateSubjects.genre.name}
        </a>
      </span>);
  },

  renderBodyDetails() {
    return (
      <div>
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.updateSubjects.book.description} />
      </div>
    );
  },

  renderBody() {
    return <BookWithWTRButton book={this.props.updateSubjects.book}
                              body={this.renderBodyDetails()} />;
  },

  renderFooter() {
    return (
      <div className="gr-newsfeedItem__footerActions">
        <PreviewBook book={this.props.updateSubjects.book}/>
      </div>
    );
  },

  render() {
    return (
      <NonsocialUpdate
        header={this.renderHeader()}
        body={this.renderBody()}
        footer={this.renderFooter()}
        {...this.props}
      />);
  },
});
